import { CurrencyName, FinancialAccountTypes } from '@webapp/models/enums'
import { type FinancialAccountTypeEnum } from '@webapp/platform/banking/entities/enums/FinancialAccountTypeEnum'

const canadaFlag = require('!svg-url-loader!../../assets/img/country_flags/canada.svg')
const unitedStatesFlag = require('!svg-url-loader!../../assets/img/country_flags/united_states.svg')

export const getFinancialAccountCurrencyAttributes = (
  financialAccountType: FinancialAccountTypeEnum
) => {
  let currencyIcon: string
  let currencyName: CurrencyName

  switch (financialAccountType) {
    case FinancialAccountTypes.AIRWALLEX_USD:
      currencyIcon = unitedStatesFlag
      currencyName = CurrencyName.USD
      break
    case FinancialAccountTypes.AIRWALLEX_CAD:
      currencyIcon = canadaFlag
      currencyName = CurrencyName.CAD
      break
    default:
      currencyIcon = undefined
      currencyName = undefined
  }

  return {
    currencyIcon,
    currencyName,
  }
}
